import React, { useEffect, useState } from 'react';
import classes from './CustomizeAI.module.scss';
import { putRequest } from '../../helpers/httpHandler2';
import { Prompt } from './AICallingInterface';

interface CustomizeAIProps {
  prompt?: Prompt;
  setPrompt: React.Dispatch<React.SetStateAction<Prompt | undefined>>;
}

const CustomizeAI = ({ prompt, setPrompt }: CustomizeAIProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [savedPrompt, setSavedPrompt] = useState<Prompt>();
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);

  useEffect(() => {
    setSavedPrompt(prompt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      await putRequest('/api/ai/prompt', prompt);
      setSavedPrompt(prompt);
      setIsEditing(false);
      setShowSaveSuccess(true);
      setTimeout(() => setShowSaveSuccess(false), 2000);
    } catch (error) {
      // Optionally set an error state here for UI feedback
      console.error('Error saving prompt:', error);
    }
  };

  const handleCancel = () => {
    setPrompt(savedPrompt);
    setIsEditing(false);
  };

  const handlePromptChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setPrompt((prev) => (prev ? { ...prev, text } : { text, id: 0 }));
  };

  return (
    <div className={classes['container']}>
      <div className={classes['header']}>
        <h2 className={classes['title']}>AI Prompt Editor</h2>
        <div className={classes['status']}>
          {showSaveSuccess && (
            <span className={classes['successMessage']}>
              ✓ Saved successfully!
            </span>
          )}
        </div>
      </div>

      <div className={classes['editorContainer']}>
        <div className={classes['toolbar']}>
          <span className={classes['label']}>System Prompt</span>
          <div className={classes['actions']}>
            {!isEditing ? (
              <button onClick={handleEdit} className={classes['editButton']}>
                Edit
              </button>
            ) : (
              <div className={classes['editActions']}>
                <button
                  onClick={handleCancel}
                  className={classes['cancelButton']}
                >
                  Cancel
                </button>
                <button onClick={handleSave} className={classes['saveButton']}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>

        <div className={classes['promptContainer']}>
          {isEditing ? (
            <textarea
              value={prompt?.text}
              onChange={handlePromptChange}
              className={classes['textarea']}
              placeholder='Enter your AI prompt here...'
              autoFocus
            />
          ) : (
            <div className={classes['promptDisplay']}>
              {prompt?.text || 'No prompt set'}
            </div>
          )}
        </div>

        <div className={classes['footer']}>
          <div className={classes['charCount']}>
            {prompt?.text?.length ?? 0} characters
          </div>
          <div className={classes['mode']}>
            Mode: {isEditing ? 'Editing' : 'View'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizeAI;
